import { useHistory } from 'react-router';
import { useNavigate } from 'hooks';
import { useItemsConditionConfigData } from 'hooks/useItemsConditionConfigData';
import { useSelectedCampaign } from 'modules/campaigns/hooks/useSelectedCampaign';
import { useReportPage, useSelectedReportId } from 'modules/campaigns/modules/campaigns-reports/hooks';
import { useReportForceFetchFlag } from 'modules/campaigns/modules/campaigns-reports/hooks/useReportForceFetchFlag';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useMultiLayerDrawerEnabled } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';

export const useBulkActionData = ({ selectedRows }) => {
    const [selectedReport] = useSelectedReportId();
    const selectedAccount = useAccount();
    const { accountName } = selectedAccount;
    const history = useHistory();
    const [, forceFetchReport] = useReportForceFetchFlag();
    const [reportPage, setReportPage] = useReportPage();
    const { campaign: selectedCampaign } = useSelectedCampaign();
    const configAndPermissions = useItemsConditionConfigData();
    const navigate = useNavigate();
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    return {
        selectedRows,
        selectedAccount,
        accountName,
        history,
        reportPage,
        setReportPage,
        forceFetchReport,
        selectedReport,
        selectedCampaign,
        navigate,
        isMultiLayerDrawerEnabled,
        ...configAndPermissions,
    };
};
